import React from 'react';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';

const Skeleton = asyncRoute(() => import('../../../../components/Skeleton'));

Skeleton.defaultProps = {
  animation: 'pulse',
  borderRadius: '0.57em',
};

export { Skeleton };
export { default as CouponCardSkeleton } from './CouponCardSkeleton';
